export const IS_SESSION_TIMED_OUT = 'IS_SESSION_TIMED_OUT';
export const ACCESS_TOKEN_TIMER = 'ACCESS_TOKEN_TIMER';
export const ACCESS_TOKEN_AUTH_CHECK = 'ACCESS_TOKEN_AUTH_CHECK';
export const SET_SESSION_TIMED_OUT_MSG = 'SET_SESSION_TIMED_OUT_MSG';
export const CLEAR_SESSION_TIMED_OUT_MSG = 'CLEAR_SESSION_TIMED_OUT_MSG';
